import React from "react"
import Post from '../components/blog-post'
import WuformButton from '../components/wuform-button'
import LayoutDumpster from "../components/layout-dumpster"
import SuccessBtnDumpsters from "../components/success-btn-dumpsters"

const PROGUIDEXXXPAGEDUMPSTERS = ({ pageContext }) => 
{ 
    const title = pageContext.post.title !== undefined ? pageContext.post.title : '';  
    const post = pageContext.post; 
    const env = pageContext.env;
    const code = pageContext.code;
    
    const seo = 
    {
        url: post.url,
        env: env,
        code: code,
        page: 'guide',
        blog: post
    }

    return (
        <LayoutDumpster seo={seo} code={code} env={env} hidden={true} callToAction={true}>

            <div className="blog">
                <div className="container mb-5">
                    <div className="row">
                        <div className="col-lg-8">
                            <h1 className="main-title">{title}</h1>
                            <div className="posts">
                                <Post post={post} />
                            </div>                            
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar">                                                 
                                <div className="block">
                                    <WuformButton />
                                </div>
                                <div className="block">                                    
                                    <SuccessBtnDumpsters />
                                </div>
                            </div>                            
                        </div>
                    </div>
                </div>                         
            </div> 
        </LayoutDumpster>
    )
};

export default PROGUIDEXXXPAGEDUMPSTERS;